export enum TravelExpensesKind {
  UNBEKANNT = 'UNBEKANNT',
  BELEGE_OHNE_REISE = 'BELEGE_OHNE_REISE',
  STANDARD = 'STANDARD',
  BELEGE_OHNE_REISE_2 = 'BELEGE_OHNE_REISE_2',
  KREDITKARTENABRECHNUNG = 'KREDITKARTENABRECHNUNG',
}
